import script from "./TaxLiablityBusinessIncome.vue?vue&type=script&setup=true&lang=js"
export * from "./TaxLiablityBusinessIncome.vue?vue&type=script&setup=true&lang=js"

import "./TaxLiablityBusinessIncome.vue?vue&type=style&index=0&id=356c79b8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-356c79b8"]])

export default __exports__